import { Alert, Button } from '@mantine/core'

import IconAlertTriangle from 'src/icons/IconAlertTriangle'

const UNRESOLVED_TOKEN_PATTERN = /(\{\{[^{}<>]*\}\})/g
const HTML_TAG_OR_TOKEN_PATTERN = /(<[^>]*>)|(\{\{[^{}<>]*\}\})/g
const MARK_CLASS = 'rounded-sm bg-doubleNickel-warning-100 px-0.5 text-inherit'

export const findUnresolvedTokens = (text: string): string[] =>
  Array.from(new Set(text.match(UNRESOLVED_TOKEN_PATTERN) ?? []))

export const markUnresolvedTokens = (html: string): string =>
  html.replace(HTML_TAG_OR_TOKEN_PATTERN, (match, tag: string | undefined) =>
    tag ? tag : `<mark class="${MARK_CLASS}">${match}</mark>`
  )

export const HighlightedPreviewText = ({ text }: { text: string }) => (
  <span className="whitespace-pre-wrap">
    {text.split(UNRESOLVED_TOKEN_PATTERN).map((part, index) =>
      index % 2 === 1 ? (
        <mark key={index} className={MARK_CLASS}>
          {part}
        </mark>
      ) : (
        part
      )
    )}
  </span>
)

export const UnresolvedVariablesNotice = ({ tokens }: { tokens: string[] }) =>
  tokens.length === 0 ? null : (
    <Alert
      icon={
        <IconAlertTriangle className="h-4 w-4 fill-none stroke-doubleNickel-warning-500" />
      }
      color="yellow"
      variant="light"
      classNames={{ root: 'py-2', body: 'gap-0', message: 'text-xs' }}
    >
      Not a variable, sent as written: {tokens.join(', ')}
    </Alert>
  )

export const PreviewUnavailable = ({ onRetry }: { onRetry: () => void }) => (
  <div className="flex h-full flex-1 flex-col items-center justify-center gap-1 text-doubleNickel-gray-600">
    <span>Preview unavailable.</span>
    <Button variant="subtle" size="xs" onClick={onRetry}>
      Try again
    </Button>
  </div>
)
